import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetNoticePageParams } from "apis/data-contracts";

const useNoticesQuery = (options: GetNoticePageParams) => {
  return useSuspenseQuery({
    queryKey: api.notice.getNoticePageKey(options),
    queryFn: () => api.notice.getNoticePage(options),
  });
};

export default useNoticesQuery;
